define(["underscore","bluebird","urijs","@bingads-webui-clientcenter/common-utils","@bingads-webui/http-util"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__33__, __WEBPACK_EXTERNAL_MODULE__34__, __WEBPACK_EXTERNAL_MODULE__271__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 267);
/******/ })
/************************************************************************/
/******/ ({

/***/ 14:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__14__;

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(268);


/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _index.RestfulService;
  }
});

var _index = __webpack_require__(269);

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToFormData = exports.RestfulService = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _commonUtils = __webpack_require__(34);

var _http = _interopRequireDefault(__webpack_require__(270));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var buildFormData = _commonUtils.FileUtils.buildFormData;

var convertToFormData = function convertToFormData(data) {
  return data instanceof FormData ? data : buildFormData(new FormData(), data);
};

exports.convertToFormData = convertToFormData;

var finalOptions = function finalOptions(data, options) {
  // If used by File Upload then do not JSONStringify data nor set the contentType
  var useFormDataFormat = options && options.useFormDataFormat;
  var defaultOptions;

  if (useFormDataFormat) {
    // Refer to https://stackoverflow.com/questions/19617996/file-upload-without-form/26690647#26690647
    defaultOptions = {
      data: convertToFormData(data),
      processData: false,
      contentType: false,
      dataType: 'json'
    };
  } else if (!_underscore.default.isString(data)) {
    defaultOptions = {
      data: JSON.stringify(data),
      contentType: 'application/json',
      dataType: 'json'
    };
  } else {
    defaultOptions = {
      data: data,
      dataType: 'json'
    };
  }

  return _underscore.default.defaults({}, options, defaultOptions);
};

var RestfulService =
/*#__PURE__*/
_createClass(
/**
 * Constructor for restful service
 * @param {Function} cidFetcher - method for getting the cid - this is a method so that it can handle the cid changing
 * @param {Function} uidFetcher - method for getting the uid - this is a method so that it can handle the uid changing
 * @param {Object} ccuiAlertCenter - if in use, the alert center to show alerts in
 * @param {Function} handleAjaxAuthFailure - method for handling AjaxAuthFailures
 * @param {Function} appendErrorSummary - method for adding errors
 * @param {Function} ajaxSuccess - method to use when ajax call was successful
 * @param {Boolean} willSupportCors - when true, it'll add a xhrFields.withCredentials=true and x-requested-with=xhr by default
 */
function RestfulService() {
  var _this = this;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cidFetcher = _ref.cidFetcher,
      uidFetcher = _ref.uidFetcher,
      ccuiAlertCenter = _ref.ccuiAlertCenter,
      handleAjaxAuthFailure = _ref.handleAjaxAuthFailure,
      appendErrorSummary = _ref.appendErrorSummary,
      ajaxSuccess = _ref.ajaxSuccess,
      _ref$willSupportCors = _ref.willSupportCors,
      willSupportCors = _ref$willSupportCors === void 0 ? false : _ref$willSupportCors;

  _classCallCheck(this, RestfulService);

  _defineProperty(this, "get", function (uri) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var settings = _underscore.default.defaults({}, options, {
      dataType: 'json'
    });

    return _this.http.get(uri, settings);
  });

  _defineProperty(this, "post", function (uri) {
    var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var settings = finalOptions(attrs, options);
    return _this.http.post(uri, settings);
  });

  _defineProperty(this, "put", function (uri) {
    var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var settings = finalOptions(attrs, options);
    return _this.http.put(uri, settings);
  });

  _defineProperty(this, "patch", function (uri) {
    var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var settings = finalOptions(attrs, options);
    return _this.http.patch(uri, settings);
  });

  _defineProperty(this, "delete", function (uri) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var settings = _underscore.default.defaults({}, options, {
      dataType: 'json'
    });

    return _this.http.delete(uri, settings);
  });

  this.http = new _http.default({
    cidFetcher: cidFetcher,
    uidFetcher: uidFetcher,
    ccuiAlertCenter: ccuiAlertCenter,
    handleAjaxAuthFailure: handleAjaxAuthFailure,
    appendErrorSummary: appendErrorSummary,
    ajaxSuccess: ajaxSuccess,
    willSupportCors: willSupportCors
  });
});

exports.RestfulService = RestfulService;

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _bluebird = _interopRequireDefault(__webpack_require__(14));

var _urijs = _interopRequireDefault(__webpack_require__(33));

var _httpUtil = __webpack_require__(271);

var _ajaxHelper = _interopRequireDefault(__webpack_require__(272));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultSetting = {
  __adcenterAJAX: true,
  data: {},
  contentType: 'application/json',
  dataType: null,
  onsuccessEventData: {},
  traditional: false,
  silent: false
};
var antiForgeryTokenKey = '__RequestVerificationToken';

function addAntiForgeryToken(options) {
  var antiForgeryTokenInput = document.querySelector("input[name=\"".concat(antiForgeryTokenKey, "\"]"));
  var antiForgeryToken = antiForgeryTokenInput && antiForgeryTokenInput.value;

  var method = _underscore.default.result(options.method, 'toUpperCase');

  if (antiForgeryToken) {
    switch (options.contentType) {
      case 'application/json':
        options.headers = _underscore.default.extend({}, options.headers, _defineProperty({}, antiForgeryTokenKey, antiForgeryToken));
        break;

      case 'application/x-www-form-urlencoded':
        if (method && method !== 'GET' && method !== 'DELETE') {
          options.data = _underscore.default.extend({}, options.data, _defineProperty({}, antiForgeryTokenKey, antiForgeryToken));
        }

        break;

      case false:
        if (options.useFormDataFormat && options.data instanceof FormData && !options.data.get(antiForgeryTokenKey)) {
          options.data.append(antiForgeryTokenKey, antiForgeryToken);
        }

        break;

      default:
        break;
    }
  }
}

function appendQuery(uri, options, defaultValue) {
  var param = _underscore.default.isObject(options.params) ? options.params : {};
  param = _underscore.default.defaults(param, defaultValue);
  return new _urijs.default(uri).addQuery(param).toString();
}

var _default =
/*#__PURE__*/
_createClass(function _default(_ref) {
  var _this = this;

  var cidFetcher = _ref.cidFetcher,
      uidFetcher = _ref.uidFetcher,
      ccuiAlertCenter = _ref.ccuiAlertCenter,
      handleAjaxAuthFailure = _ref.handleAjaxAuthFailure,
      appendErrorSummary = _ref.appendErrorSummary,
      ajaxSuccess = _ref.ajaxSuccess,
      _ref$willSupportCors = _ref.willSupportCors,
      willSupportCors = _ref$willSupportCors === void 0 ? false : _ref$willSupportCors;

  _classCallCheck(this, _default);

  _defineProperty(this, "ajax", function (uri, options, cb) {
    var extendedOptions = _underscore.default.defaults({}, options, defaultSetting);

    if (_this.willSupportCors === true) {
      var defaultCorsHeaders = {
        'X-Requested-With': 'XMLHttpRequest'
      };
      extendedOptions.headers = _underscore.default.extend({}, defaultCorsHeaders, extendedOptions.headers);
      var defaultCorsXhrFields = {
        withCredentials: true
      };
      extendedOptions.xhrFields = _underscore.default.extend({}, defaultCorsXhrFields, extendedOptions.xhrFields);
    }

    addAntiForgeryToken(extendedOptions);
    extendedOptions.beforeSend = _this.ajaxHelper.beforeSend(extendedOptions);
    extendedOptions.success = _this.ajaxHelper.success(extendedOptions);
    extendedOptions.error = _this.ajaxHelper.error(extendedOptions);
    extendedOptions.complete = _this.ajaxHelper.complete(extendedOptions);
    var cidUidQueryParam = {};

    if (_underscore.default.isFunction(_this.cidFetcher)) {
      var cid = _this.cidFetcher();

      _underscore.default.extend(cidUidQueryParam, {
        cid: cid
      });
    }

    if (_underscore.default.isFunction(_this.uidFetcher)) {
      var uid = _this.uidFetcher();

      _underscore.default.extend(cidUidQueryParam, {
        uid: uid
      });
    } // append cid and uid to the url


    var integrateUri = appendQuery(uri, extendedOptions, cidUidQueryParam);
    return _httpUtil.http.ajax(integrateUri, extendedOptions, cb).then(function (res) {
      return res.Errors ? _bluebird.default.reject(res) : _bluebird.default.resolve(res);
    });
  });

  _defineProperty(this, "defaults", function (options) {
    return function () {
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      var _http$signature = _httpUtil.http.signature(params),
          _http$signature2 = _slicedToArray(_http$signature, 3),
          url = _http$signature2[0],
          opt = _http$signature2[1],
          callback = _http$signature2[2];

      var op = _underscore.default.defaults({}, opt, options);

      return _this.ajax(url, op, callback);
    };
  });

  _defineProperty(this, "get", this.defaults({
    method: 'get'
  }));

  _defineProperty(this, "put", this.defaults({
    method: 'put'
  }));

  _defineProperty(this, "post", this.defaults({
    method: 'post'
  }));

  _defineProperty(this, "patch", this.defaults({
    method: 'patch'
  }));

  _defineProperty(this, "delete", this.defaults({
    method: 'delete'
  }));

  this.cidFetcher = cidFetcher;
  this.uidFetcher = uidFetcher;
  this.willSupportCors = willSupportCors;
  this.ajaxHelper = new _ajaxHelper.default({
    ccuiAlertCenter: ccuiAlertCenter,
    handleAjaxAuthFailure: handleAjaxAuthFailure,
    appendErrorSummary: appendErrorSummary,
    ajaxSuccess: ajaxSuccess
  });
});

exports.default = _default;

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__271__;

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
_createClass(function _default() {
  var _this = this;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      ccuiAlertCenter = _ref.ccuiAlertCenter,
      _ref$handleAjaxAuthFa = _ref.handleAjaxAuthFailure,
      handleAjaxAuthFailure = _ref$handleAjaxAuthFa === void 0 ? _underscore.default.noop : _ref$handleAjaxAuthFa,
      _ref$appendErrorSumma = _ref.appendErrorSummary,
      appendErrorSummary = _ref$appendErrorSumma === void 0 ? _underscore.default.noop : _ref$appendErrorSumma,
      _ref$ajaxSuccess = _ref.ajaxSuccess,
      ajaxSuccess = _ref$ajaxSuccess === void 0 ? _underscore.default.noop : _ref$ajaxSuccess;

  _classCallCheck(this, _default);

  _defineProperty(this, "beforeSend", function (options) {
    return _underscore.default.wrap(options.beforeSend, function (func, xhr) {
      if (options.useAlertCenter && _this.ccuiAlertCenter && options.alertId) {
        _this.ccuiAlertCenter.dismiss(options.alertId);
      }

      if (_underscore.default.isFunction(func)) {
        func(xhr);
      }
    });
  });

  _defineProperty(this, "success", function (options) {
    return _underscore.default.wrap(options.onSuccess, function (func, data, textStatus, xhr) {
      _this.handleAjaxAuthFailure(data);

      if (options.useAlertCenter && options.alertId) {
        if (data && _this.ccuiAlertCenter) {
          if (!_underscore.default.isEmpty(data.Errors)) {
            _this.ccuiAlertCenter.appendWarning(data.Errors, options.alertId);
          } else if (!_underscore.default.isEmpty(data.Info)) {
            _this.ccuiAlertCenter.appendInfo(data.Info, options.alertId);
          } else if (!_underscore.default.isEmpty(data.Confirmation)) {
            _this.ccuiAlertCenter.appendSuccess(data.Confirmation, options.alertId);
          }
        }
      } else if (data && !_underscore.default.isEmpty(data.Errors)) {
        if (_underscore.default.isFunction(options.onJsonError)) {
          options.onJsonError(data, textStatus, xhr);
        } else {
          _this.appendErrorSummary(data.Errors);
        }
      } else if (data && !_underscore.default.isEmpty(data.Alert)) {
        _this.ajaxSuccess(data);
      }

      if (_underscore.default.isFunction(func)) {
        func(data, textStatus, options.data, options.onsuccessEventData, xhr);
      }
    });
  });

  _defineProperty(this, "error", function (options) {
    return _underscore.default.wrap(options.onAjaxError, function (func, xhr, textStatus, errorThrown) {
      if (_underscore.default.isFunction(func)) {
        func(xhr, textStatus, errorThrown);
      }
    });
  });

  _defineProperty(this, "complete", function (options) {
    return _underscore.default.wrap(options.onAjaxComplete, function (func, xhr, textStatus) {
      if (_underscore.default.isFunction(func)) {
        func(xhr, textStatus);
      }
    });
  });

  this.ccuiAlertCenter = ccuiAlertCenter;
  this.handleAjaxAuthFailure = handleAjaxAuthFailure;
  this.appendErrorSummary = appendErrorSummary;
  this.ajaxSuccess = ajaxSuccess;
});

exports.default = _default;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__33__;

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__34__;

/***/ })

/******/ })});;
